import { pwd } from "shelljs";

//西班牙语
export default {
    login_module: {
        Login: 'Iniciar sesión',
        Register: 'Regístrate',
        noAccount: '¿Aún no tienes una cuenta?',
        hasAccount: '¿Ya tiene una cuenta? ',
        loginSuccess:'Inicio de sesión exitoso!',
        IAgree: 'Estoy de acuerdo',
        rememberMe: 'Recuérdame',
        lostPassword: '¿Olvidó su contraseña?',
        send: 'Enviar',
        userName: 'Nombre de usuario',
        mailAddress: 'Correo Electrónico',
        pwdFormat: 'La contraseña debe tener entre 6 y 18 caracteres y debe contener números, letras.',
        pwdConfirmFormat: 'No es la misma contraseña capturada en los dos espacios.',
        pasConfirm: 'Confirmación de contraseña',
        pleaseInput: 'Por favor, introduzca',
        name: 'Nombre',
        inputName: 'Por favor, introduzca su nombre.',
        userNameFormat: 'El nombre de usuario solo puede contener caracteres alfanuméricos o guiones simples, y no puede comenzar o terminar con un guión.',
        password: 'Contraseña',
        email: 'Correo',
        inputEmail: 'Por favor, introduzca el buzón',
        emailFormatError: 'Error de formato de correo electrónico',
        enterEmail: 'Ingrese su correo electrónico abajo y le enviaremos las instrucciones de restablecimiento.',
        selectCountry: 'Seleccionar País',
        verificationCode: 'Código de verificación',
        verificationFormat: 'El código de verificación es incorrecto',
        CountryRegion: 'País/región',
        inputPwd: 'Por favor, introduzca la contraseña',
        activationPrompt: 'Enviaremos un correo de activación a su buzón, por favor, inicie sesión después de activarlo en el buzón.'
    },
    overview_module: {
        //overview
        today: 'Hoy.',
        detectionQuantity: 'Cantidad de detección',
        abnormalQuantity: 'Cantidad de resultados anormales',
        dailyDetection: 'Detección diaria',
        detectionItems: 'Detectar elementos',
        bloodSugar: 'azúcar en la sangre',
        bloodKetones: 'Cetonas en sangre',
        uricAcid: 'ácido úrico',
        lactate: 'Lactato',
        mailbox: 'buzón',
        detectionTime: 'Tiempo de detección',
        detectionValue: 'Valor de detección',
        unit: 'Unidad',
        search: 'Buscar',
        enterName: 'Ingresar nombre',
        gender: 'Género',
        male: 'Masculino',
        female: 'Femenino',
        date: 'Fecha',
        //时段
        allGlucose: 'Todo el azúcar en sangre',
        midnight: 'Medianoche',
        earlyMorning: 'Amanecer',
        afterBreakfast: 'Después del desayuno',
        beforeLunch: 'Antes del almuerzo',
        afterLunch: 'Después del almuerzo',
        beforeDinner: 'Antes de la cena',
        afterDinner: 'Después de la cena',
        bedtime: 'Hora de acostarse'
    },
    table: {
        all: 'Todos',
        display: 'Mostrar ',
        records: 'Archivos',
        unused: 'No utilizado',
        used: 'Utilizado',
    },
    aside: {
        //侧边栏
        overview: 'General',
        myPatients: 'Mis pacientes',
        personalInfo: 'Información personal',
        allPatients: 'Todos pacientes',
        inviteCodes: 'Códigos de invitación',
        code: 'Código',
        changePwd: 'Cambiar contraseña',
        allDoctors: 'Todos los doctores',
        allAgent: 'Todas las agentes',
        allInviteCodes: 'Todos los códigos de invitación',
        operations: 'Operaciones',
        feedback: 'Retroalimentación',
        software: 'Software'
    },
    footer: {
        service: 'Privacidad y términos de servicio',
        support: 'Obtener soporte'
    },
    patient_module: {
        //patient
        remind: 'Recordar',
        sendMsg: 'Enviar mensaje',
        DMType: 'Tipo de diabetes',
        lastUploadTime: 'Última vez de carga',
        device: 'Dispositivo',
        lastMeasureTime: 'Tiempo de detección final',
        country: 'País',
        type1: 'Tipo I',
        type2: 'Tipo II',
        otherForms: 'Otras formas',
        GDM: 'Tipo gestacional',
        typePre: 'Prediabetes',
        typeSpecial: 'Tipo especial',
    },
    patient_detail_module: {
        confirmationTime: 'DM Fecha',
        addNote: 'Añadir Notas',
        enterNote: 'Por favor, introduzca la información de la nota.',
        editNote: 'Nota del editor',
        confirmDeleteNote: 'Determinar la eliminación de Notas',
        unbind: 'Desligado',
        table: 'Tabla',
        logbook: 'Cuadernillo',
        trends: 'Tendencias',
        period: 'Período',
        Days: 'Días',
        other: 'Otras ',
        AvgDailyRange: 'Lecturas diarias promedio en rango',
        AvgDailyNo: 'Promedio diario de la cantidad de lecturas de BGM',
        readingRange: 'Lecturas en rango',
        avgBG: 'Glucosa media en sangre',
        DerivedFrom: 'Derivado de',
        BGMReadings: 'BGM lecturas',
        weeks: 'Semanas',
        monday: 'Lu',
        tuesday: 'Ma',
        wednesday: 'Mi',
        thursday: 'Ju',
        friday: 'Vi',
        saturday: 'Sá',
        sunday: 'Do',
        group: 'Grupo',
        range: 'Rango ',
        avg: 'Promedio',
        min: 'Valor mínimo',
        max: 'Valor máximo',
        low: 'Bajo',
        normal: 'Normal',
        high: 'Alto',
        time:'veces',
        medicine: 'Leki',
        food: 'Comida',
        sport: 'Deporte',
        DMInfo: 'Información de diabetes',
        height: 'Altura',
        weight: 'Peso',
        PreMealSugarCtrlTgt: 'Objetivo de control de glucosa antes de las comidas',
        PostprandialSugarCtrlTgt: 'Objetivo de control de glucosa después de las comidas',
        info: 'informaciones ',
        useDevice: 'dispositivos',
        associatedDoc: 'Doctores asociados',
        associatedAgent: 'Agentes asociados',
        lastLoginTime: 'Última vez de login',
        uploadMethod: 'Método de carga',
        addMethod: 'Cómo agregarlo',
        manualAddition: 'Añadir manualmente',
        realTime: 'Medición en tiempo real',
        historical: 'Medición histórica',
        recordTime: 'Tiempo record',
        dose: 'Dosis',
        type: 'Tipo',
        calories: 'Calorías',
        carbs: 'Carbohidratos',
        proteins: 'Proteínas',
        fats: 'Grasas',
        strength: 'Intensidad',
        duration: 'Duración',
        sendCustomerConfirm: 'Enviaremos el contenido directamente al cliente, confírmelo repetidamente.',
        selectExportedTime: 'Seleccione el rango de tiempo de los datos exportados',
        from: 'de',
        to: 'a',
        verificationCode: 'Código de verificación',
        verificationFormat: 'El código de verificación es incorrecto',
        DetectionStats: 'Detection statistics',
        addedToday: 'Agregado hoy',
        addedWeek: 'Agregado esta semana',
        addedMonth: 'Nuevo este mes',
        remarksNoEmpty: 'Los comentarios no pueden estar vacíos',
        selectTableTime: 'Seleccione el rango de tiempo de los datos de la tabla.',
        startDate: 'Fecha de inicio',
        endDate: 'Fecha de finalización',
        belowRange: 'Lectura por debajo del rango',
        inRange: 'Lecturas en el rango',
        aboveRange: 'Lectura por encima del rango',
        pleaseSelectTimeRange: '¡Por favor seleccione un rango de tiempo!',
    },
    weekdays: {
        Sun: 'Domingo',
        Mon: 'Pon',
        Tue: 'Wto',
        Wed: 'Śro',
        Thu: 'Czw',
        Fri: 'Pią',
        Sat: 'Sábado'
    },
    info_module: {
        basicInfo: 'Información básica',
        avatar: 'Foto de perfil',
        birthday: 'Fecha de nacimiento',
        chooseDate: 'Seleccionar fecha',
        selfIntro: 'Auto presentación',
        PEIntro: 'Introducción a la experiencia profesional',
        oldPwd: 'Contraseña anterior',
        newPwd: 'Contraseña nueva',
        inputOldPwd: 'Por favor, introduzca la contraseña original',
        inputNewPwd: 'Por favor, introduzca una nueva contraseña',
        inputPwdAgain: 'Por favor, introduzca la contraseña de nuevo'
    },
    invite_module: {
        add: 'Añadir',
        Use: 'Utilizar',
        push:"Empujar",
        pushMail: 'Correo a invitar',
        remarks: 'Notas',
        creationTime: 'Tiempo de creación',
        phone:'Teléfono móvil',
        pushPhone: 'Empujar el teléfono',
        phoneInfo: 'Enviaremos el Código de invitación al teléfono. Por favor, recuerde a su paciente que lo verifique.',
        action: 'Acción',
        generateCode: 'Generar código de invitación',
        codeInfo: 'Enviaremos un correo con el código de activación a la dirección de su correo electrónico. Recuerde a su paciente que lo revise.'
    },
    system_module:{
        welcome:'Bienvenido,@{name}!',
        welcomeMsg:'VivaGuard le proporcionará mejores herramientas de gestión de la glucosa en sangre. Ahora puede iniciar sesión en la aplicación VivaGuard y comenzar a registrar su glucosa!',
        changePwd:'Cambiar contraseña',
        changePwdFor:'Cambiar contraseña para @{name}',
        pwdInfo:'La contraseña debe contener una letra, un número y tener una longitud de 6 caracteres.',
        resend:'Reenviar',
        resendInfo:'Su cuenta aún no ha sido activada. Enviamos un correo electrónico con el código de activación a su dirección de correo electrónico registrada.',
        actived:'¿Completar activación?',
        toLogin:'Haga clic para iniciar sesión!',
        resendSuccess:'Reenviado con éxito!',
        resendFailed:'Reenviado con fallo!',
    },
    operation: {
        promot: 'Consejos',
        edit: 'Editar',
        save: 'Guardar',
        yes: 'Confirmado',
        delete: 'Eliminar',
        saveSend: 'Guardar y enviar',
        rePush: 'Volver a invitar',
        cancel: 'Cancelación',
        exit: 'Salir',
        confirmExit: '¿Confirmar la salida?',
        confirmDelete: '¿Confirmar la eliminación?',
        addSuccessed: '¡Se agregó con éxito!',
        editSuccessed: '¡Actualización exitosa!',
        successfullyDelete: 'Eliminado con éxito'
    },
    notification:{
        1000: 'Token expirado',
        1001: 'Token expirado',
        1002: 'Error del sistema',
        1003: 'Error de parámetro!',
        1006: 'Error de parámetro!',
        1008: 'Enviaremos un correo electrónico con el código de activación a su dirección de correo electrónico registrada. Por favor, active su cuenta en su dirección de correo electrónico antes de iniciar sesión!',
        1026: 'No vuelva a enviar!!!',
        6000: 'El archivo es demasiado grande!',
        100001: 'Cuenta ya registrada!',
        100002: 'Email o contraseña incorrectos.',
        100004: 'Cuenta no existe!',
        100005: 'Cuenta no activada!',
        100006: 'Cuenta ya activada!',
        100007: 'Cuenta bloqueada!',
        100008: 'La contraseña original es incorrecta!',
        100011: 'Error al enviar el correo electrónico, por favor inténtelo de nuevo!',
        200000: 'Código de verificación expirado!'
    },
    back:"Volver"
}


// WEBPACK FOOTER //
// ./src/i18n/lang/es.js